interface UserIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const clipId = 'clip0_user_icon';

const UserIcon = ({ width = 14, height = 14, className }: UserIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath={`url(#${clipId})`}>
      <path
        d="M12.25 14.0003H10.5V11.0837C10.5 10.7742 10.3771 10.4775 10.1583 10.2587C9.9395 10.0399 9.64275 9.91699 9.33333 9.91699H4.66667C4.35725 9.91699 4.0605 10.0399 3.84171 10.2587C3.62292 10.4775 3.5 10.7742 3.5 11.0837V14.0003H1.75V11.0837C1.75093 10.3104 2.05851 9.56907 2.60529 9.02229C3.15208 8.47551 3.8934 8.16792 4.66667 8.16699H9.33333C10.1066 8.16792 10.8479 8.47551 11.3947 9.02229C11.9415 9.56907 12.2491 10.3104 12.25 11.0837V14.0003Z"
        fill="currentColor"
      />
      <path
        d="M7 7C6.30777 7 5.63108 6.79473 5.05551 6.41015C4.47993 6.02556 4.03133 5.47894 3.76642 4.83939C3.50152 4.19985 3.4322 3.49612 3.56725 2.81719C3.7023 2.13825 4.03564 1.51461 4.52513 1.02513C5.01461 0.535644 5.63825 0.202301 6.31719 0.0672531C6.99612 -0.0677952 7.69985 0.0015165 8.33939 0.266423C8.97894 0.53133 9.52556 0.979934 9.91015 1.55551C10.2947 2.13108 10.5 2.80777 10.5 3.5C10.4991 4.42798 10.13 5.31768 9.47385 5.97385C8.81768 6.63003 7.92798 6.99908 7 7ZM7 1.75C6.65388 1.75 6.31554 1.85264 6.02775 2.04493C5.73997 2.23722 5.51567 2.51054 5.38321 2.83031C5.25076 3.15008 5.2161 3.50194 5.28363 3.84141C5.35115 4.18088 5.51782 4.4927 5.76256 4.73744C6.00731 4.98218 6.31913 5.14885 6.65859 5.21638C6.99806 5.2839 7.34993 5.24924 7.6697 5.11679C7.98947 4.98434 8.26278 4.76004 8.45507 4.47225C8.64737 4.18446 8.75 3.84612 8.75 3.5C8.75 3.03587 8.56563 2.59075 8.23744 2.26256C7.90925 1.93438 7.46413 1.75 7 1.75Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id={clipId}>
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default UserIcon;
